import React, { useState } from 'react';
import { Globals } from '../utils';

interface Props {
  src?: string
  placeholder: string
  className?: string
  placeholderClassName?: string
  alt?: string
}

const FallbackImage = ({ src, placeholder, className, placeholderClassName, alt = 'Foto' }: Props) => {
  const isExternal = String(src || '').startsWith('http') || String(src || '').startsWith('blob') || String(src || '').startsWith('data');
  const uri = isExternal ? src : Globals.fromPhotos(src || '');
  const [isBroken, setIsBroken] = useState(false);

  if (!src || isBroken) return (
    <img key="" src={placeholder} className={placeholderClassName} alt={alt} />
  );

  return (
    <img src={uri} className={className} onError={() => setIsBroken(true)} alt={alt} />
  );
};

export default FallbackImage;
